import React from 'react';
import templeimg from '../assets/temple2.png';
import ombg from '../assets/om.png';
import panditjiImg from '../assets/panditji.jpg';
import founder from '../assets/founder.jpg';

const About = () => {
  return (
    <div className="flex relative flex-col items-center w-full max-md:max-w-full">
      <div
        className="w-[80%] rounded-[20px] bg-cover bg-center px-[20px] py-[30px] md:p-[30px]"
        style={{
          backgroundImage: `url(${templeimg})`,
        }}
      >
        <div className="bg-[#430F07] bg-opacity-55"></div>
        <div className="bg-[#9B2912] bg-opacity-80 px-3 py-4 md:p-8 text-white rounded-[20px] h-full">
          <h2 className="text-[40px] md:text-[52px] font-[Noto Sans Devanagari] font-bold mb-6 text-center">
            मंदिर का इतिहास
          </h2>
          <div className="flex flex-col md:flex-row items-center md:items-start justify-center md:justify-between md:gap-3">
            <div className="w-full md:w-[40%] rounded-[10px] flex flex-col items-center justify-center">
              <div className="w-[250px] h-[250px] flex items-center justify-center mx-auto md:mx-0 rounded-full overflow-hidden mb-4 bg-white">
                <img
                  src={founder}
                  alt="Pandit Murlidhar Ramakrishnan"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="font-afacad text-[20px] font-bold flex items-center justify-center">
                Late Manu Bhai Patel
              </h3>
            </div>
            <p className="text-[20px] md:text-[24px] lg:text-[28px] font-afacad text-center md:text-left mt-6 md:mt-0 md:ml-6">
            Shri Hanuman Mandir in Jersey City was founded in 2008 by the late Manu Bhai Patel and his family with a heartfelt vision — to create a sacred space for devotion, prayer, and the preservation of Hindu values far from home. Located on the third floor at 781 Newark Avenue, the temple has become a spiritual anchor for the community. Every Saturday, devotees gather for a live Sunderkand recital followed by Maha Bhog (prasad), filling the space with devotion and unity. The temple also hosts vibrant celebrations of festivals like Hanuman Jayanti, Ram Navami, and Navratri, continuing to uplift and unite thousands through the spirit of service, faith, and tradition.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-10">
        <div className="hidden md:block max-w-6xl mt-20 px-4 mb-10">
          <h2 className="md:block text-[60px] font-abhaya text-center text-[#800000] mb-10">
            Temple Priest
          </h2>

          <div className="flex flex-col md:flex-row items-stretch w-full gap-10">
            <div
              className="w-[30%] text-center bg-[#fdf2e9] p-6 shadow-lg rounded-[10px] flex flex-col items-center justify-center"
              style={{ backgroundImage: `url(${ombg})` }}
            >
              <div className="flex items-center justify-center mx-auto rounded-full overflow-hidden mb-4">
                <img
                  src={panditjiImg}
                  alt="Pandit Murlidhar Ramakrishnan"
                  className="w-[191px] h-full object-cover"
                />
              </div>
              <h3 className="font-afacad text-[20px] font-bold">
                Shashtri GajendraKumar V Jani
              </h3>
            </div>

            <div
              className="w-[70%] flex items-center p-6 rounded-lg shadow-lg"
              style={{ backgroundImage: `url(${ombg})` }}
            >
              <p className="text-[24px] font-afacad">
                <strong>Shree Hanumanji Mandir</strong> is blessed to have the
                guidance and spiritual leadership of{' '}
                <strong>Shashtri GajendraKumar V Jani</strong>, an esteemed and
                devoted priest with profound knowledge in Sanatan Dharma
                traditions. With years of dedicated service, Panditji performs
                sacred rituals including Shree Satyanarayan Katha, Vastu Shanti
                Havan, Baby Showers, Marriages, Mundans, and various other
                auspicious ceremonies. He also conducts Navchandi Paath,
                Sundarkand Paath, and Bhajan-Kirtan events, spreading divine
                blessings and fostering a spiritual atmosphere in the community.
              </p>
            </div>
          </div>
        </div>

        <div className="block md:hidden">
          <div
            className="w-full text-center bg-[#fdf2e9] p-6 shadow-lg rounded-[10px]"
            style={{ backgroundImage: `url(${ombg})` }}
          >
            <h2 className="md:block text-[60px] font-abhaya text-center text-[#800000] mb-10">
              Temple Priest
            </h2>
            <div className="flex items-center justify-center mx-auto rounded-full overflow-hidden mb-4">
              <img
                src={panditjiImg}
                alt="Pandit Murlidhar Ramakrishnan"
                className="w-[191px] h-full object-cover"
              />
            </div>
            <h3 className="font-afacad text-[20px] font-bold my-[20px]">
              Shashtri GajendraKumar V Jani
            </h3>
            <p className="text-[24px] font-afacad">
              <strong>Shree Hanumanji Mandir</strong> is blessed to have the
              guidance and spiritual leadership of{' '}
              <strong>Pandit GajendraKumar V Jani</strong>, an esteemed and
              devoted priest with profound knowledge in Sanatan Dharma
              traditions. With years of dedicated service, Panditji performs
              sacred rituals including Shree Satyanarayan Katha, Vastu Shanti
              Havan, Baby Showers, Marriages, Mundans, and various other
              auspicious ceremonies. He also conducts Navchandi Paath,
              Sundarkand Paath, and Bhajan-Kirtan events, spreading divine
              blessings and fostering a spiritual atmosphere in the community.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
